




























































































import Vue from "vue";
import Component from "vue-class-component";
import { mapState, mapActions } from "vuex";
import { required, minLength, email } from "vuelidate/lib/validators";
import { validationMixin, Validation } from "vuelidate";
import { AxiosError } from "axios";

interface Login {
    email: string;
    password: string;
    rememberMe: boolean;
}

@Component({
    mixins: [validationMixin]
})
export default class extends Vue {
    login: Login = {
        email: "",
        password: "",
        rememberMe: true
    };
    submitted: boolean = false;
    error: string | null = null;

    async mounted() {
        try {
            var result = await this.$http.get("/api/v0/users/me");
            await this.doLogin();
        } catch {
            // We likely 401'd so present with the login page
        }
    }

    async submitLogin() {
        this.error = null;
        if (this.$v.$invalid) {
            return;
        }

        this.submitted = true;
        try {
            await this.$http
                .post("/api/v0/authentication/login", this.login)
                .catch((error: AxiosError) => {
                    if (error?.response?.status == 401) {
                        throw "Login Failed";
                    }

                    throw error?.message;
                });
            await this.doLogin();
        } catch (error) {
            this.error = error;
            this.submitted = false;
            this.login.password = "";
        }
    }

    async doLogin() {
        await this.$store.dispatch("login");
        await this.$router.push({ name: "home" });
    }

    validations() {
        return {
            login: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            }
        };
    }
}
